import { ThemeProvider } from "@mui/material";
import { createRoot } from "react-dom/client";
import { ToastContainer } from "react-toastify";

import { config } from "service-worker/serviceWorkerRegistrationConfig";
import * as serviceWorkerRegistration from "serviceWorkerRegistration";
import { posteMessageToServiceWorkerWithPWAType } from "utils/pwa";
import { muiGlobalTheme } from "muiGlobalTheme";
import reportWebVitals from "reportWebVitals";
import { AppProviders } from "AppProviders";

import "Layouts/Common/fontAwesome";
import "utils/i18n/i18nManager";
import "./index.scss";
import "./toast.scss";

import { msalInstance, loginRequest } from "utils/azureAD/authConfig";
import { EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";

// 1. Gérer les événements MSAL
msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const username = payload.account?.username;
    console.log("LOGIN_SUCCESS:", username);
  }

  if (event.eventType === EventType.LOGIN_FAILURE) {
    console.error("LOGIN_FAILURE:", event.error);
  }
});

msalInstance.handleRedirectPromise().then((result) => {
  if (result && result.account) {
    console.log("🔁 Redirection terminée pour :", result.account.username);
  }

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    console.log("Pas connecté, redirection...");
    msalInstance.loginRedirect(loginRequest);
  } else {
    console.log("Déjà connecté :", accounts[0].username);
  }

  const container = document.getElementById("root");
  const root = createRoot(container!);

  root.render(
    <ThemeProvider theme={muiGlobalTheme}>
      <AppProviders />
      <ToastContainer
        position="bottom-center"
        autoClose={false}
        closeOnClick={false}
        limit={1}
      />
    </ThemeProvider>
  );

  posteMessageToServiceWorkerWithPWAType();
  serviceWorkerRegistration.register(config);
  reportWebVitals();

}).catch((error) => {
  console.error("Erreur lors du handleRedirectPromise:", error);
});
